import ModalContainer from '../ModalContainer';
// import Input from '../../components/form/Input';
import Button from '../../components/form/Button';

const AddEditLayoutModal = ({
  isBtn = true,
  show = false,
  disabled = false,
  title = '',
  onClose = () => {},
  onSubmit = () => {},
  modalSize = '',
  children
}) => {
  return (
    <ModalContainer show={show} title={title} closeModal={onClose} modalSize={modalSize}>
      <div className='relative'>
        <div className='mb-4 flex flex-col'>
          <div className='space-y-4 mt-4'>
            <div className='flex items-start gap-4'>
              {/* <div className='relative w-full'>
                <Input
                  label={'Category Name'}
                  labelClasses={'!text-xs'}
                  inputType={'text'}
                  inputPlaceholder={'Enter Category Name'}
                  inputValue={''}
                  setInput={() => {}}
                />
              </div> */}
              { children }
            </div>
          </div>
        </div>
        { isBtn &&
        <div className='pt-3 px-6 -mx-6 border-t border-slate-200'>
          <div className='flex items-center justify-center gap-4'>
           
            <Button
              buttonClasses='!w-full'
              buttonLabelClasses=''
              buttonType={'button'}
              buttonIcon={
                disabled
                  ? 'fa-light fa-spinner fa-spin'
                  : 'fa-light fa-check'
              }
              buttonIconPosition={'left'}
              buttonLabel={'Submit'}
              functions={onSubmit}
              buttonHasLink={false}
              buttonDisabled={disabled}
            />
          </div>
        </div>
}
      </div>
    </ModalContainer>
  );
};

export default AddEditLayoutModal;
